<ng-template #actionTabs>
  @if (tabs) {
    <div class="tab-container">
      <coin-tab-selection
        class="tab-selection"
        [tabs]="tabs"
        [withoutRouting]="withoutRouting"
        (tabChange)="tabChange.emit($event)"></coin-tab-selection>
    </div>
  }
</ng-template>

<ng-template #closeButtons>
  @if (displayCloseButton) {
    <div class="close-dialog-button-wrapper">
      <button (click)="closeClick.emit($event)">
        <mat-icon>close</mat-icon>
        {{ 'general.btnClose' | translate }}
      </button>
    </div>
  }
</ng-template>

<coin-sub-component-header
  [title]="title"
  [titleContainer]="titleContainer"
  [actionContainerLeft]="actionContainerLeft"
  [actionContainerMiddle]="actionContainerMiddle ?? actionTabs"
  [actionContainerRight]="displayCloseButton ? closeButtons : actionContainerRight"></coin-sub-component-header>
